<template>
  <span class="d-inline-block">
    <b-button
      class="m-2"
      size="sm"
      variant="outline-success"
      @click="novaLicenca"
    >
      <i class="mdi mdi-upload"></i> Enviar Nova Licença
    </b-button>

    <NovaLicencaModal
      v-model="abrirNovaLicencaModal"
      :servidor="servidor"
      v-on:enviarLicenca="enviarLicenca"
    />
  </span>
</template>

<script>
import NovaLicencaModal from "./NovaLicencaModal.vue";

export default {
  name: "novaLicencaBtn",
  components: {
    NovaLicencaModal
  },
  props: {
    servidor: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      abrirNovaLicencaModal: false
    };
  },
  methods: {
    novaLicenca() {
      this.abrirNovaLicencaModal = true;
    },
    enviarLicenca(licenca) {
      this.$emit("enviarLicenca", licenca.licencaExpiraEm);
    }
  }
};
</script>

<style lang="scss" scoped></style>
